import React, {Component}  from 'react'
import moment from "moment"

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import { Progress, Popover } from 'antd'

import {on_migration_progress} from "../../../actions/migrations"

import './styles.scss'

class TransferIndicator extends Component{

  constructor (props) {
    super(props)

    this.state = {
      migrations:{}
    }

    moment.relativeTimeThreshold('m', 60) //Number.MAX_VALUE
    moment.relativeTimeThreshold('s', 60)
    moment.relativeTimeThreshold('ss', 0)
  }

  componentWillReceiveProps(props) {
    this.setState({migrations:props.migrations.ongoing})
  }

  on_show_dashboard = ()=>{
    let { history } = this.props
    history = history || window.appHistory
    history.push('/mboard')
  }

  render() {
    let {migrations={}} = this.state
    migrations = Object.values(migrations).filter(m=> m.status !== 'Succeeded' && m.status !== 'Canceled' && (m.progress||{}).percent !== 100)

    return (migrations.length && window.location.pathname !== '/mboard') ? (
      <div className={'transfer-indicator'} onClick={()=>this.on_show_dashboard()}> {
          migrations.map((migration={}, index ) =>{
            let {files={}, cloud:dest_cloud, bucket:dest_bucket_name, type,
              percent:migration_percent=0, error:migration_error='', processing, succeeded, transferred } = migration
            files = Object.values(files)||[]
            const {cloud=''} = (files[0]||{})
            let migration_status = migration_percent < 100 ? (migration_error ? 'exception' : 'active'): 'success'

            return (
              <div className='transfer-progress' key={index} onClick={()=>this.on_show_dashboard()}>
                <Popover placement="leftBottom" overlayClassName={'popover-transfer-progress'}
                content={
                <div>
                  <span>{`${cloud ? (cloud + ' → ' + dest_cloud + ' → ' + dest_bucket_name) : ('starting ...')}`}</span>

                  <span>{'Processing : ' + processing}</span>
                  <span>{'Enqueued   : ' + files.filter(f=> (f.progress||{}).percent === 0).length}</span>
                  <span>{'Succeeded  : ' + succeeded}</span>
                </div>
                }>
                  <Progress type="circle" width={50} percent={parseFloat(migration_percent) ? parseInt(parseFloat(migration_percent).toFixed(0)) : 0} strokeWidth={5} status={migration_status} showInfo={true}/>
                </Popover>
              </div>
            )
          })}
      </div>
    ):null
  }
}

export default withRouter(connect(({migrations={}}) => ({migrations}), dispatch => bindActionCreators({on_migration_progress}, dispatch))(TransferIndicator))
